const FIXED_RECORD_TYPES = [
  { value: 'clientinsurance', label: 'Insurance', recordType: 'clientinsurance', keyType: 'ClientInsurance' },
  { value: 'clientprovider', label: 'Providers', recordType: 'clientprovider', keyType: 'ClientProvider' },
  { value: 'clientdiagnosis', label: 'Diagnosis', recordType: 'clientdiagnosis', keyType: 'ClientDiagnosis' }
];

export const buildRecordTabs = (settings, allTemplates) => {
  const preferredItems = settings?.clientRecordTemplates;
  
  if (!preferredItems || preferredItems.length === 0) {
    // No preferences - return empty array to show empty state
    return [];
  }
  
  // Build tabs from user preferences, validating each item
  const tabs = [];
  
  preferredItems.forEach(item => {
    if (item === 'clientinsurance' || item === 'clientprovider' || item === 'clientdiagnosis') {
      // Fixed record type
      const fixedType = FIXED_RECORD_TYPES.find(t => t.value === item);
      if (fixedType) {
        tabs.push(fixedType);
      }
    } else if (item.startsWith('template-')) {
      // Template-based record type
      const templateId = item.substring(9); // Remove 'template-' prefix
      const template = allTemplates.find(t => t.id === templateId);
      if (template) {
        tabs.push({
          value: `template-${template.id}`,
          label: template.displayName || template.templateName || template.id,
          templateId: template.id
        });
      }
    }
    // Invalid items are silently ignored
  });
  
  return tabs;
};

export const buildRecordNavItems = (settings, allTemplates, clientId, recordsEnabled = true) => {
  const debugInfo = {
    recordsEnabled,
    hasSettings: !!settings,
    templatesCount: allTemplates?.length || 0,
    clientRecordTemplates: settings?.clientRecordTemplates || []
  };
  console.log('[buildRecordNavItems]', JSON.stringify(debugInfo, null, 2));
  
  if (!recordsEnabled) {
    return [];
  }
  
  const tabs = buildRecordTabs(settings, allTemplates);
  console.log('[buildRecordNavItems] tabs:', tabs?.length || 0, tabs);
  const navItems = [];

  // Always add provider, insurance, and diagnosis records - these are not managed by RecordTypeManager
  navItems.push({
    key: 'providers',
    link: `/apps/client/${clientId}/records/providers`,
    icon: 'heroicons-outline:user-group',
    text: 'Providers'
  });

  navItems.push({
    key: 'insurance',
    link: `/apps/client/${clientId}/records/insurance`,
    icon: 'heroicons-outline:shield-check',
    text: 'Insurance'
  });

  navItems.push({
    key: 'diagnosis',
    link: `/apps/client/${clientId}/records/diagnosis`,
    icon: 'heroicons-outline:clipboard-document-list',
    text: 'Diagnosis'
  });

  // Only show templated records if they are configured
  const templatedTabs = tabs.filter(tab => tab.templateId);
  console.log('[buildRecordNavItems] templatedTabs:', templatedTabs);
  if (templatedTabs.length > 0) {
    if (templatedTabs.length === 1) {
      // Single template - show directly
      const tab = templatedTabs[0];
      const template = allTemplates.find(t => t.id === tab.templateId);
      const isClientFacing = template?.clientFacing === true;
      navItems.push({
        key: `template-${tab.templateId}`,
        link: `/apps/client/${clientId}/records/template/${tab.templateId}`,
        icon: isClientFacing ? 'material-outline:portrait' : 'heroicons-outline:document-text',
        text: tab.label
      });
    } else {
      // Multiple templates - show as expandable group
      navItems.push({
        key: 'templated-records',
        link: `/apps/client/${clientId}/records`,
        icon: 'heroicons-outline:document-text',
        text: 'Client Records',
        children: templatedTabs.map(tab => {
          const template = allTemplates.find(t => t.id === tab.templateId);
          const isClientFacing = template?.clientFacing === true;
          return {
            key: `template-${tab.templateId}`,
            link: `/apps/client/${clientId}/records/template/${tab.templateId}`,
            icon: isClientFacing ? 'material-outline:portrait' : 'heroicons-outline:document-text',
            text: tab.label
          };
        })
      });
    }
  } else {
    // No templated records configured - show link to main records page for empty state
    navItems.push({
      key: 'templated-records',
      link: `/apps/client/${clientId}/records`,
      icon: 'heroicons-outline:document-text',
      text: 'Client Records'
    });
  }
  

  
  return navItems;
};

export const validateRecordTypes = (types, allTemplates) => {
  return types.filter(type => {
    if (type === 'clientinsurance' || type === 'clientprovider' || type === 'clientdiagnosis') {
      return FIXED_RECORD_TYPES.some(t => t.value === type);
    } else if (type.startsWith('template-')) {
      const templateId = type.substring(9);
      return allTemplates.some(t => t.id === templateId);
    }
    return false;
  });
};

export const getAvailableRecordTypes = (allTemplates) => {
  // Only return template types - fixed types (insurance/providers) are always available
  const types = [];
  
  allTemplates.forEach(template => {
    types.push({
      value: `template-${template.id}`,
      label: template.displayName || template.templateName || template.id,
      clientFacing: template.clientFacing === true,
      status: template.status
    });
  });
  
  return types;
};

export { FIXED_RECORD_TYPES };